import currency from './currency';

export default {
  showTitle: (data) => {
    var product     = data.product;
    var collections = data.collections;
    var vendor      = product.vendor;

    if(vendor) {
      //Get the vendor collection (if exists)
      var col = _.find(collections, (c) => {
        return c.title.toLowerCase() == vendor.toLowerCase();
      });

      //Link (if there is one)
      var vendor_html = (col) ? `<a href="/collections/${col.handle}" class="vendor">${col.title.toUpperCase()}</a>` : `<span class="vendor">${vendor.toUpperCase()}</span>`

      return `${vendor_html}, ${product.title}`;
    }

    return product.title;
  },
  hasTabs: (data) => {
    var html = data.product.description;
    return !!(html.indexOf('<!--split') > -1);
  },
  formatTabs: (data, view, which='title') => {
    var has_tabs = view.product.hasTabs(data);
    var html = data.product.description;
    var tabs = [];

    if(!has_tabs) return (which == 'title') ? ['Details'] : [data.product.description];

    if(which == 'title') {
      tabs = ['Details'];

      // Get all the splits
      var regex  = /<!--split name="(.*?)"-->/g;
      var splits = html.match(regex);
      if(splits) {
        tabs = tabs.concat(_.map(splits, (s) => {
          
          return s.replace('<!--split name="',"").replace('"-->',"")
        }))
      }
    } else {
      //Description
      tabs = html.split(/<!--split name="(?:.*?)"-->/g);
    }

    return tabs
  },
  showUrl: (handle) => {
    return `/products/${handle}`;
  },
  showShipping: (settings) => {
    return settings.product_shipping;
  },
  showOptionClass: (state, id) => {
    return (state.product.active_options == id) ? "active" : "";
  },
  showStickyClass: (state) => {
    return {
      'sticky-disabled': state.product.sticky_disabled
    }
  },
  showStickyStyle: (state) => {
    if(!state.product.sticky_disabled) return {top:0};

    return {
      top: state.product.sticky_top + 'px'
    };
  },
  showBuyClass: (state) => {
    return {
      'buy-error': state.product.error != false
    }
  },
  showTotal: (state, view) => {
    var total = parseInt(state.product.selected_variant.price) * parseInt(state.product.selected_quantity);

    return view.currency.showPrice(state,view,{
      price: total
    });

  },
  showPrice: (state, view, variant, modifier = '') => {
    var original_price = (variant.original_price) ? variant.original_price : variant.compare_at_price;
    // if(modifier == 'product') {
      var price =  view.currency.showPrice(state,view,{
        price:variant.price,
        original:original_price
      });

      if(!variant.available) price = '<span class="sold">Sold Out</span>';
    // } else {
      // return currency.showPrice(data, state.currency.code);
    // }
    
    return price;
  },
  hasSalePrice: (state, view, variant) => {
    var price    = variant.price;
    var original = variant.compare_at_price;
    return original != null && original > price;
  },
  showImage: (url, format) => {
    //Split url by '.'
    var dot_pos = (~-url.lastIndexOf(".") >>> 0) + 1;
    // Insert format in string
    return [url.slice(0,dot_pos), `_${format}`, url.slice(dot_pos)].join('');
  },
  formatSlideshow(s,images, opts_switch = '') {
    return _.chain(images)
      .map( (img, idx) => {
        return {
          alt: img.alt,
          url: img.url,
          width: img.width,
          height: img.height,
          class: (s.product.selected_slide == idx) ? 'active' : ''
        }
      })
      .value()
  },
  formatGallery(s,images) {
    return _.map(images, (img, idx) => {
        return {
          alt: img.alt,
          url: img.url
        }
      });
  },
  hasOptions: (data) => {
    return data.product.variants.length > 1;
  },
  formatOptions: (data) => {
    var options = [];

    _.each(data.product.options, (ot, ot_idx) => {
      options[ot_idx] = {
        type: ot,
        type_index: ot_idx
      };

      options[ot_idx].values = _.chain(data.product.variants)
        .map((variant, variant_idx) => {
          //Format sizes as numbers
          return variant.options[ot_idx];
        })
        .uniq()
        .value()
    });

    return options;
  },
  showBuyText: (state) => {
    var string     = "Add to Cart"
    var variant    = state.product.selected_variant;
    var cart_state = state.cart;

    //Available state
    if(variant != -1) {
      if(variant.available) {
        string = "Add to Cart";
      } else {
        string = "Sold Out";
      }
    } 

    //Adding to cart
    if(cart_state.current_action == "adding") string = "Adding to Cart";
    if(cart_state.current_action == "added")  string = "Added to Cart";

    return string;
  },
  showBuyMessage: (data, state) => {
    var variant    = state.product.selected_variant;
    var quantity   = variant.inventory_quantity;
    var management = variant.inventory_management;
    var policy     = variant.inventory_policy;
    var message    = state.product.message;
    
    //If shopify is handling inventory
    if(management == 'shopify'){
      //Preorders allowed and no stock
      if(policy == 'continue' && quantity < 1) {
        message = data.settings.product_preorder;
      }
      if(policy == 'deny' && quantity < 1) {
        message = data.settings.product_notify;
      }

      // if(quantity < 3 && quantity > 0) {
      //   message = `Only ${quantity} left in stock`;
      // }
    }

    return message;
  },
  showOptionClass: (state,option,option_value) => {
    var ot_index         = option.type_index;
    var selected_options = state.product.selected_options;

    return (selected_options[ot_index] && selected_options[ot_index] == option_value) ? "active" : "";
  },
  getBuyAvailability: (data, state) => {
    var variant   = state.product.selected_variant;
    var available = variant.available;

    return available;
  },
  showNotify: (data, state) => {
    var product = data.product;
    var variant   = state.product.selected_variant;
    var available = variant.available;
    var is_notifiable = _.includes(product.tags, 'notifiable');

    return (is_notifiable && !available) ? true : false;
  },
  isNotified: (state) => {
    var get = [];
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){ get[name]=value; });

    return (!!get['contact_posted'])
  }
}